import { userProfileDatasource } from 'data/datasources/userprofile.datasource';
import { IUserProfile } from 'data/entities/userprofile.entity';

interface IUserProfileRepository {
    getUserProfile(): Promise<IUserProfile | null>;
}

class UserProfileRepository implements IUserProfileRepository {
    public getUserProfile(): Promise<IUserProfile | null> {
        return userProfileDatasource.getUserProfile();
    }
}

export const userProfilesRepository: IUserProfileRepository = new UserProfileRepository();
